import { render, staticRenderFns } from "./EbitdaTopFive.vue?vue&type=template&id=b466c504"
import script from "./EbitdaTopFive.vue?vue&type=script&lang=js"
export * from "./EbitdaTopFive.vue?vue&type=script&lang=js"
import style0 from "./EbitdaTopFive.vue?vue&type=style&index=0&id=b466c504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports